const masterclassSteps = [
  {
    id: 0,
    nextStep: 1,
    area: 'Masterclass',
    masterclass: true,
    stepTitle: '1Get Started with the DIFF Center',
    stepDescription: `<p>To join the DIFF Center, all new users must first complete our two-hour
          <strong>Life-Changing Masterclass: How to Become a Transformative Black
          Visionary Leader.</strong> This foundational course provides essential historical
          context on Black economic disparities and equips you with the mindset to
          drive meaningful change.</p><br /> <strong>Why the Masterclass?</strong>
          <p>
          This masterclass explores pivotal historical events that shaped today’s
          economic landscape, inspiring you to see yourself as a powerful agent of
          change. It’s designed to transform your understanding and prepare you to
          fully engage with the DIFF Center's resources.
          </p>
          <br />
          <strong>Steps to Access the Platform</strong><br />
          <br />
        <ul class="disc">
        <li> <strong>Complete the Masterclass </strong><br /> Start with the mandatory masterclass to gain critical insights and build the mindset essential for impactful change.</li>
        <li class="mt-5"> <strong>Take the Test & Record a Testimonial</strong><br /> 
        After the masterclass, complete a brief test and record a testimonial on
          how it impacted you. Only those who score 100% on the test will gain
          full platform access. This ensures that every member begins with the
          knowledge needed for meaningful growth. (Note: A release and waiver
          agreement will be included for promotional use of testimonials.)
        </li>
        <li class="mt-5"><strong>Unlock Full Access</strong><br /> 
        Once you pass, explore our specialized tracks—Finances &
        Philanthropy and Entrepreneurship & Philanthropy—and access
        practical tools, workshops, and a supportive community designed to
        elevate Black wealth and empowerment.
        </li>
    
      </ul>`,
    subSteps: {
      0: {
        subStepTitle: 'Get Started with the DIFF Center',
        subStepDescription: `<p>To join the DIFF Center, all new users must first complete our two-hour
          <strong>Life-Changing Masterclass: How to Become a Transformative Black
          Visionary Leader.</strong> This foundational course provides essential historical
          context on Black economic disparities and equips you with the mindset to
          drive meaningful change.</p><br /> <strong>Why the Masterclass?</strong>
          <p>
          This masterclass explores pivotal historical events that shaped today’s
          economic landscape, inspiring you to see yourself as a powerful agent of
          change. It’s designed to transform your understanding and prepare you to
          fully engage with the DIFF Center's resources.
          </p>
          <br />
          <strong>Steps to Access the Platform</strong><br />
          <br />
      
       <ul class="accordion-list min-[992px]:disc">
  <li>
    <details>
      <summary><strong>Complete the Masterclass</strong></summary>
      <p> Start with the mandatory masterclass to gain critical insights and build the mindset essential for impactful change.</p>
    </details>
  </li>
  <li>
    <details>
      <summary><strong>Take the Test & Record a Testimonial</strong></summary>
      <p> After the masterclass, complete a brief test and record a testimonial on
          how it impacted you. Only those who score 100% on the test will gain
          full platform access. This ensures that every member begins with the
          knowledge needed for meaningful growth. (Note: A release and waiver
          agreement will be included for promotional use of testimonials.)</p>
    </details>
  </li>
  <li>
    <details>
      <summary><strong>Unlock Full Access</strong></summary>
      <p> 
        Once you pass, explore our specialized tracks—Finances &
        Philanthropy and Entrepreneurship & Philanthropy—and access
        practical tools, workshops, and a supportive community designed to
        elevate Black wealth and empowerment.</p>
    </details>
  </li>

</ul>`,
        subStepVideoUrl: '',
      },
      1: {
        subStepTitle: 'Online Resource Center Masterclass',
        subStepDescription: `<p>Embark on a transformative journey with this Masterclass, uniquely designed to empower Black leaders, entrepreneurs, and wealth builders with insights rooted in both historical context and global perspective. Unlike any other economic empowerment program, this series combines the wisdom of Black history with forward-thinking strategies to create lasting wealth and impact. Led by inspiring Black leaders, each session equips you with essential tools across four core areas:
          </p>
          <br />
          <strong>In this comprehensive program, you'll gain insights from
inspirational leaders on:</strong>

        <br />
          <br />
          <ul class="accordion-list">
  <li>
    <details>
      <summary><strong>Visionary Leadership</strong></summary>
      <p>  
      Learn to see the world through a historically grounded and globally aware lens. Discover how to build a vision that honors the Black community's rich past while steering boldly toward a future of empowerment and resilience.
      </p>
          </details>
  </li>
  <li>
    <details>
      <summary><strong>Entrepreneurship Essentials</strong></summary>
      <p>  
    Master the fundamentals of business building with a focus on legacy and sustainability. From concept to execution, gain insights into how entrepreneurship, guided by historical awareness, can drive both personal success and community advancement.
      </p>
          </details>
  </li>
    <li>
    <details>
      <summary><strong>Building Wealth</strong></summary>
      <p>  
  Explore wealth-building strategies designed to address and overcome the specific economic disparities that Black communities face globally. Understand how business ownership can bridge gaps, create generational wealth, and strengthen Black financial influence worldwide.
      </p>
          </details>
  </li>
      <li>
    <details>
      <summary><strong>The Power of Philanthropy</strong></summary>
      <p>  
  Uncover the art of giving back through a global lens. Learn how impactful philanthropy, grounded in historical consciousness, not only benefits communities today but also honors the legacy of those who came before us.
      </p>
          </details>
  </li>
      </ul>
      <br />
       <p>  
     With these pillars, this Masterclass offers a unique blend of historical insight and practical strategy, guiding you to become a visionary leader who not only achieves personal success but also contributes to the global Black community. Ready to chart a course toward a legacy of empowerment, wealth, and lasting change? Let’s begin.

      </p>
      `,
        subStepVideoUrl: 'https://firebasestorage.googleapis.com/v0/b/online-resource-center.appspot.com/o/Masterclass%2F1-Teaches-Transformative%20Black-Visionary-Leadership-Intro.mp4?alt=media&token=efef9399-e2b3-48bb-ad10-a5313b2721a5',
      },
      2: {
        subStepTitle: 'Visionary Leaders: Charismatic Soothsayers & Knowledge Seekers',
        subStepDescription: `<p>This section explores the traits and perspectives of visionary leaders.</p>`,
        subStepVideoUrl: 'https://firebasestorage.googleapis.com/v0/b/online-resource-center.appspot.com/o/Masterclass%2F2-Visionary-Leaders-Charismativ-Soothsayers-Knowledge-Seekers.mp4?alt=media&token=fb1f3f22-b388-48a5-a5cf-1534dfe4eaa5',
        questions: [
          {
            id: 1,
            title: "How do visionary leaders see the world?",
            options: [
              'As a dangerous place that can only be changed by those born into power.',
              'As a place that they can envision differently and take steps to change.',
              'As an ever-changing space that changes on its own without the need for human effort.'
            ],
            correctAnswer: 'As a place that they can envision differently and take steps to change.'
          },
          {
            id: 2,
            title: "What are the key characteristics of successful visionary leaders?",
            options: [
              'Historically conscious risk-takers and forecasters who are charismatic and passionate.',
              'Short-sighted dictators who lack wisdom.',
              'Impulsive and dependent on the visions of others to create a vision for themselves.'
            ],
            correctAnswer: 'Historically conscious risk-takers and forecasters who are charismatic and passionate.'
          },
          {
            id: 3,
            title: "What keywords should you think of in relation to visionary leadership?",
            options: [
              'Complacency, short-term, dispossession and subjugation.',
              'Original, flighty, successful and dictatorial.',
              'Innovation, sustainability, ownership and power.'
            ],
            correctAnswer: 'Innovation, sustainability, ownership and power.'
          }
        ]
      },
      3: {
        subStepTitle: 'Black Visionary Leadership Begins With Understanding The Global Black Community',
        subStepDescription: `<p>This section delves into the global Black community and its shared experiences.</p>`,
        subStepVideoUrl: 'https://firebasestorage.googleapis.com/v0/b/online-resource-center.appspot.com/o/Masterclass%2F3.%20It%20Begins%20With%20Understanding%20The%20Global%20Black%20Community.mp4?alt=media&token=e1cf27dd-52b1-445d-a71f-62b9d3baa052',
        questions: [
          {
            id: 4,
            title: "What is the global Black community?",
            options: [
              'A UN term used to describe Black heads of states all over the world.',
              'An alliance of Black people who recognize Africa as their ancestral home.',
              'Black people all over the world who are connected by their common African ancestral home.'
            ],
            correctAnswer: 'Black people all over the world who are connected by their common African ancestral home.'
          },
          {
            id: 5,
            title: "What historical experiences do the majority of Black people share regardless of where they are from?",
            options: [
              'Slavery and colonialism.',
              'Segregation and apartheid.',
              'War and displacement.'
            ],
            correctAnswer: 'Slavery and colonialism.'
          },
          {
            id: 6,
            title: "What power is inherent in interactions between Black people from different walks of life?",
            options: [
              'There is opportunity to share experiences of discrimination and find comfort.',
              'There is opportunity to take collective action and start a movement that could change the world.',
              'There is opportunity to explore differences and understand why collaboration would not be possible.'
            ],
            correctAnswer: 'There is opportunity to take collective action and start a movement that could change the world.'
          },
          {
            id: 7,
            title: "What is the general concept of Black automatic collectivity?",
            options: [
              'The notion that regardless of where a Black person is from or what they have accomplished, they are seen as the same.',
              'The notion that Black people automatically understand each other as a result of being Black.',
              'The notion that Black people organically work as a collective due to their race.'
            ],
            correctAnswer: 'The notion that regardless of where a Black person is from or what they have accomplished, they are seen as the same.'
          }
        ]
      },
      4: {
        subStepTitle: 'Black Visionary Leadership Requires Being Historically & Globally Conscious',
        subStepDescription: `<p>This section highlights the importance of historical and global consciousness in Black visionary leadership.</p>`,
        subStepVideoUrl: 'https://firebasestorage.googleapis.com/v0/b/online-resource-center.appspot.com/o/Masterclass%2F4.%20It%20Requires%20Being%20Historically%20%26%20Globally%20Conscious.mp4?alt=media&token=8c9a52a8-e3fd-4c4e-b622-c63e45402e62',
        questions: [
          {
            id: 8,
            title: "What core issue do all Black people struggle with?",
            options: [
              'A collective lack of entrepreneurial ability.',
              'A collective lack of identity.',
              'A collective lack of economic power.'
            ],
            correctAnswer: 'A collective lack of economic power.'
          },
          {
            id: 9,
            title: "Why is it important to have Black historical and global consciousness as a Black person?",
            options: [
              "It helps you understand how the different groups within the global Black community's past, present, and future are connected...",
              "It helps you to understand how the different groups within the global Black community's past, present, and future are disconnected...",
              "It helps you to understand how you are connected to other minority groups around the world and how Black people's history is similar to theirs."
            ],
            correctAnswer: "It helps you understand how the different groups within the global Black community's past, present, and future are connected..."
          },
          {
            id: 10,
            title: "How should Black historical and global consciousness shift your overall mindset when it comes to making an impact?",
            options: [
              "It should make me shift from focusing on the macro to the micro and think more specifically in terms of making an impact only in the community I grew up in.",
              "It should make me shift from being idealistic to being realistic and realize that I do not have the power to make change in any notable way.",
              "It should make me shift from focusing on the micro to the macro and think bigger in terms of making an impact on a broader scale beyond the community I grew up in."
            ],
            correctAnswer: "It should make me shift from focusing on the micro to the macro and think bigger in terms of making an impact on a broader scale beyond the community I grew up in."
          }
        ]
      },
      5: {
        subStepTitle: 'Defining Black Visionary Leadership',
        subStepDescription: `<p>This section defines Black visionary leadership and its unique features.</p>`,
        subStepVideoUrl: 'https://firebasestorage.googleapis.com/v0/b/online-resource-center.appspot.com/o/Masterclass%2F5.%20Defining%20Black%20Visionary%20Leadership.mp4?alt=media&token=89a3a0ea-d2d6-468a-a764-a6406ea04305',
        questions: [
          {
            id: 11,
            title: "What are the unique features of DIFFvelopment's definition of Black visionary leadership?",
            options: [
              'It leverages Black historical and global consciousness to create a vision for the future.',
              'It leverages Black creativity to create a vision for the future.',
              'It leverages Black experiences to create a vision for the future.'
            ],
            correctAnswer: 'It leverages Black historical and global consciousness to create a vision for the future.'
          },
          {
            id: 12,
            title: "What are Black visionary leaders prepared to do?",
            options: [
              "They are prepared to identify, define and solve issues impacting the global minority community...",
              "They are prepared to identify, define and solve issues impacting the global BIPOC community...",
              "They are prepared to identify, define and solve issues impacting the global Black community..."
            ],
            correctAnswer: "They are prepared to identify, define and solve issues impacting the global Black community..."
          },
          {
            id: 13,
            title: "Do they see things objectively or subjectively?",
            options: [
              'Subjectively',
              'Objectively'
            ],
            correctAnswer: 'Objectively'
          },
          {
            id: 14,
            title: "What are important characteristics all Black visionary leaders should have?",
            options: [
              "They should be change seekers with a wild imagination who aren't afraid to protest against the plight of Blackness...",
              "They should be peace seekers with a conservative mindset who refrain from disrupting endemic issues...",
              "They should be knowledge seekers with a wild imagination who aren't afraid to piece together the necessary research..."
            ],
            correctAnswer: "They should be knowledge seekers with a wild imagination who aren't afraid to piece together the necessary research..."
          }
        ]
      },
      6: {
        subStepTitle: 'The Cost Of A Lack Of Visionary Leadership',
        subStepDescription: `<p>This section explores the costs associated with a lack of visionary leadership in the Black community.</p>`,
        subStepVideoUrl: 'https://firebasestorage.googleapis.com/v0/b/online-resource-center.appspot.com/o/Masterclass%2F6.%20The%20Cost%20Of%20A%20Lack%20Of%20Visionary%20Leadership.mp4?alt=media&token=5f890807-0c90-42ad-94a6-783c95ebce9a',
        questions: [
          {
            id: 15,
            title: "What historical fundamental flaw separates Black people from other groups?",
            options: [
              'An endemic lack of visionary leadership.',
              'Failure to overcome slavery.',
              'A lack of natural resources.'
            ],
            correctAnswer: 'An endemic lack of visionary leadership.'
          },
          {
            id: 16,
            title: "How can Black visionary leaders shift the trajectory of Black economics?",
            options: [
              'By addressing major present-day challenges within the context of current events.',
              'By addressing historically informed core issues instead of symptoms.',
              'By addressing the wrongdoings of the powers that be.'
            ],
            correctAnswer: 'By addressing historically informed core issues instead of symptoms.'
          }
        ]
      },
      7: {
        subStepTitle: 'Breaking The Cycle Of Low Wealth Through Visionary Black Business',
        subStepDescription: `<p>This section discusses the value of business ownership in breaking the cycle of low wealth.</p>`,
        subStepVideoUrl: 'https://firebasestorage.googleapis.com/v0/b/online-resource-center.appspot.com/o/Masterclass%2F7.%20Black%20Businesses%20Break%20The%20Cycle%20Of%20Low%20Wealth.mp4?alt=media&token=8dd5e535-2861-4584-8a61-b469e94a8438',
        questions: [
          {
            id: 17,
            title: "What is the value of business ownership in relation to breaking the cycle of low wealth?",
            options: [
              'Black business owners are 12 times wealthier than Blacks who are not business owners...',
              'Black business owners are six times wealthier than Blacks who are not business owners...',
              'Black business owners are slightly wealthier than Blacks who are not business owners...'
            ],
            correctAnswer: 'Black business owners are 12 times wealthier than Blacks who are not business owners...'
          },
          {
            id: 18,
            title: "What is the key difference between investing years into an employer and investing years into your own business?",
            options: [
              'You can get a raise through your job but cannot get a raise through your business.',
              'You can pass your job on to your descendants but cannot pass your business on to your descendants.',
              'You can pass your business on to your descendants but cannot pass your job on to your descendants.'
            ],
            correctAnswer: 'You can pass your business on to your descendants but cannot pass your job on to your descendants.'
          },
          {
            id: 19,
            title: "How does business ownership foster generational wealth?",
            options: [
              "It increases one's cash flow which in turn leads to more savings and investments.",
              'It leads to riches and fame.',
              'It is an asset and therefore presents one with the opportunity to pass it down from generation to generation.'
            ],
            correctAnswer: 'It is an asset and therefore presents one with the opportunity to pass it down from generation to generation.'
          },
          {
            id: 20,
            title: "What is the core difference between entrepreneurs and intrapreneurs?",
            options: [
              'Intrapreneurs make more money than entrepreneurs.',
              'Entrepreneurs assume their own financial risk, while employers assume financial risk on behalf of intrapreneurs.',
              'Entrepreneurs innovate, budget, hire and develop and execute plans, while intrapreneurs do none of the aforementioned.'
            ],
            correctAnswer: 'Entrepreneurs innovate, budget, hire and develop and execute plans, while intrapreneurs do none of the aforementioned.'
          }
        ]
      },
      8: {
        subStepTitle: 'Leveraging Visionary Community-Minded Business To Make Real Change',
        subStepDescription: `<p>This section explores the concept of community-minded business and its impact.</p>`,
        subStepVideoUrl: 'https://firebasestorage.googleapis.com/v0/b/online-resource-center.appspot.com/o/Masterclass%2F8.%20The%20Meaning%20%26%20Importance%20Of%20Community-Minded%20Busines.mp4?alt=media&token=870cac47-69c9-4925-9906-41371dcc9003',
        questions: [
          {
            id: 21,
            title: "What is a philanthropist?",
            options: [
              'Someone who does things for the welfare of others, oftentimes to solve deep-seated, core issues for the greater good of humanity.',
              'Someone who does things for their own benefit.',
              'Someone who does things for the welfare of others only when they expect a financial return.'
            ],
            correctAnswer: 'Someone who does things for the welfare of others, oftentimes to solve deep-seated, core issues for the greater good of humanity.'
          },
          {
            id: 22,
            title: "What are the three components of a community-minded business?",
            options: [
              'Personal, generational and communal entrepreneurship that first empowers the business owner and their employees...',
              'Personal, strategic and locational entrepreneurship that prioritizes empowering the business owner...',
              'Personal, familial and inspirational entrepreneurship that only empowers the business owner and their family members...'
            ],
            correctAnswer: 'Personal, generational and communal entrepreneurship that first empowers the business owner and their employees...'
          },
          {
            id: 23,
            title: "How do you leverage your business to build generational wealth?",
            options: [
              'By paying the bills of many people in your community and giving them money whenever they ask.',
              'By financially supporting your parents and all of the people who raised you.',
              'By developing a business succession plan and investing in members of the next generation through the sound advice of a wealth management professional.'
            ],
            correctAnswer: 'By developing a business succession plan and investing in members of the next generation through the sound advice of a wealth management professional.'
          },
          {
            id: 24,
            title: "Why is philanthropic, charitable giving smart business?",
            options: [
              "It leverages excess funds to give back to worthwhile causes while, in turn, reducing a business's taxable income.",
              'It leverages excess funds to give back to worthwhile causes, leading to press.',
              "It leverages excess funds to give back to worthwhile causes while, in turn, relieving a business from having to pay taxes."
            ],
            correctAnswer: "It leverages excess funds to give back to worthwhile causes while, in turn, reducing a business's taxable income."
          },
          {
            id: 25,
            title: "What are some of the most impactful ways business owners can participate in charitable giving?",
            options: [
              'They can attend free charitable events and tell friends and family about them.',
              'They can leverage taxable, excess funds to create a nonprofit or philanthropic arm for their for-profit...',
              'They can volunteer at a nonprofit for one day annually and blog about it.'
            ],
            correctAnswer: 'They can leverage taxable, excess funds to create a nonprofit or philanthropic arm for their for-profit...'
          }
        ]
      },
      9: {
        subStepTitle: 'Ancient African Innovation: A Source Of Visionary Inspiration',
        subStepDescription: `<p>This section examines ancient African innovations and their relevance to visionary leadership.</p>`,
        subStepVideoUrl: 'https://firebasestorage.googleapis.com/v0/b/online-resource-center.appspot.com/o/Masterclass%2F9.%20Ancient%20African%20Innovation%20A%20Source%20Of%20Inspiration.mp4?alt=media&token=222de4d7-8f44-4794-97ec-125ff50544ce',
        questions: [
          {
            id: 26,
            title: "Where did language originate?",
            options: [
              'Southern Africa',
              'Eastern Europe',
              'North Africa'
            ],
            correctAnswer: 'Southern Africa'
          },
          {
            id: 27,
            title: "What is the connection between the concept of creation and the concept of entrepreneurship?",
            options: [
              'Both are abstract concepts that are nearly impossible to achieve.',
              "Both bring something into existence that wasn't formerly there.",
              'Both require the elimination of competitors in order to achieve success.'
            ],
            correctAnswer: "Both bring something into existence that wasn't formerly there."
          },
          {
            id: 28,
            title: "Where did carbon steel originate?",
            options: [
              'East Africa',
              'Rome',
              'China'
            ],
            correctAnswer: 'East Africa'
          },
          {
            id: 29,
            title: "Where did tetracycline originate?",
            options: [
              'Greece',
              'Sudan',
              'North America'
            ],
            correctAnswer: 'Sudan'
          },
          {
            id: 30,
            title: "How are ancient African innovations indicative of Black people's inherent community-minded mindset?",
            options: [
              'They solved small problems that only benefitted specific communities.',
              'They solved problems in order to glorify those who created the solutions.',
              'They solved large problems for the benefit of the greater good.'
            ],
            correctAnswer: 'They solved large problems for the benefit of the greater good.'
          }
        ]
      },
      10: {
        subStepTitle: 'Enslaved African Entrepreneurship: A Source Of Visionary Motivation',
        subStepDescription: `<p>This section explores the entrepreneurial spirit of enslaved Africans.</p>`,
        subStepVideoUrl: 'https://firebasestorage.googleapis.com/v0/b/online-resource-center.appspot.com/o/Masterclass%2F10.%20Enslaved%20African%20Entrepreneurship%20A%20Source%20Of%20Motivation.mp4?alt=media&token=f6a9718f-3a62-4fcd-b299-a4b279c91aab',
        questions: [
          {
            id: 31,
            title: "What was the system of self-hire during slavery?",
            options: [
              'A system where slaves bought their own free time from masters in order to build businesses.',
              'A system where slaves hired themselves out to other plantations.',
              'A system where slaves bought their own free time from masters in order to travel.'
            ],
            correctAnswer: 'A system where slaves bought their own free time from masters in order to build businesses.'
          },
          {
            id: 32,
            title: "What high-level tasks were slave intrapreneurs responsible for?",
            options: [
              'Ensuring slaves did not learn how to read.',
              "Managing their masters' businesses, handling everything from hiring and firing to bookkeeping.",
              'Carrying firewood to and from plantations.'
            ],
            correctAnswer: "Managing their masters' businesses, handling everything from hiring and firing to bookkeeping."
          },
          {
            id: 33,
            title: "What did slaves typically do with the money they earned?",
            options: [
              "They bought their family's and their own freedom, and often bought land and established Black towns and other communities.",
              'They bought their own freedom and joined White communities.',
              'They bought luxury goods so they could show off to other slaves.'
            ],
            correctAnswer: "They bought their family's and their own freedom, and often bought land and established Black towns and other communities."
          },
          {
            id: 34,
            title: "How were enslaved entrepreneurs visionaries?",
            options: [
              'They saw past their situation as a slave and invested in those around them, having faith that they would be able to eventually invest in themselves and gain freedom.',
              'They dreamed about better days and waited for the powers that be to shift their trajectory.',
              'They envisioned an alternative reality and shared it with their family and other slaves in their immediate plantation community.'
            ],
            correctAnswer: 'They saw past their situation as a slave and invested in those around them, having faith that they would be able to eventually invest in themselves and gain freedom.'
          }
        ]
      },
      11: {
        subStepTitle: 'Exploring The Causes Of The Arab Slave Trade & The Issue Of Foresight',
        subStepDescription: `<p>This section explores the causes of the Arab slave trade and the importance of foresight.</p>`,
        subStepVideoUrl: 'https://firebasestorage.googleapis.com/v0/b/online-resource-center.appspot.com/o/Masterclass%2F11.%20Exploring%20The%20Causes%20Of%20The%20Arab%20Slave%20Trade%20%26%20The%20Issue%20of%20Foresight-006.mp4?alt=media&token=93c1b432-78a6-456e-9a9d-2cf112654140',
        questions: [
          {
            id: 35,
            title: "Why is it important to think about African slavery objectively?",
            options: [
              'Because it makes you aware of how unlucky Black people have been and why you should primarily associate with other racial groups.',
              "Because it empowers you to better understand the agency both African and European players had in the process of its manifestation, enabling you to develop informed ideas regarding how such facts should motivate you.",
              'Because it gives you the opportunity to see how Black people have been taken advantage of and why its time to fight back.'
            ],
            correctAnswer: "Because it empowers you to better understand the agency both African and European players had in the process of its manifestation, enabling you to develop informed ideas regarding how such facts should motivate you."
          },
          {
            id: 36,
            title: "What were the core reasons why Axum lost power?",
            options: [
              'It failed to make the necessary shifts and investments in the midst of over-reliance on exports and maintaining trade routes, food shortage, soil erosion and an insufficient administrative apparatus to manage conquered peoples.',
              'It failed to win an ongoing war with neighboring communities.',
              'It failed to take on the European way of life and accept Western domination.'
            ],
            correctAnswer: 'It failed to make the necessary shifts and investments in the midst of over-reliance on exports and maintaining trade routes, food shortage, soil erosion and an insufficient administrative apparatus to manage conquered peoples.'
          },
          {
            id: 37,
            title: "What are the legacies of the Arab slave trade?",
            options: [
              'Integration, assimilation, acceptance and sustainability.',
              'Historical consciousness, equality and socioeconomic advancement.',
              'Isolation, discrimination, disproportionate poverty, and identity crisis.'
            ],
            correctAnswer: 'Isolation, discrimination, disproportionate poverty, and identity crisis.'
          }
        ]
      },
      12: {
        subStepTitle: 'The Atlantic Slave Trade & The Cost Of Hindsight',
        subStepDescription: `<p>This section analyzes the Atlantic slave trade and the lessons learned from it.</p>`,
        subStepVideoUrl: 'https://firebasestorage.googleapis.com/v0/b/online-resource-center.appspot.com/o/Masterclass%2F12.%20The%20Atlantic%20Slave%20Trade%20%26%20The%20Cost%20of%20Hindsight-002.mp4?alt=media&token=2ad71a28-acef-4204-8ac2-f240bb61a8a0',
        questions: [
          {
            id: 38,
            title: "When did things shift for West African kingdoms in terms of their trade power?",
            options: [
              'When Europeans discovered ivory in South America...',
              'When Europeans advanced their travel technology and discovered gold in South America...',
              'When Europeans discovered gold in Haiti...'
            ],
            correctAnswer: 'When Europeans advanced their travel technology and discovered gold in South America...'
          },
          {
            id: 39,
            title: "How did the features of slavery change in Africa as a result of Europe's need for humans only?",
            options: [
              'It brought peace between different African groups and reduced the number of slaves captured by enemy forces.',
              'It increased the importation of guns and fighting between different African kingdoms and groups for the purpose of acquiring more slaves that could be sold.',
              'It made slavery in Africa less desirable and improved relations between warring kingdoms.'
            ],
            correctAnswer: 'It increased the importation of guns and fighting between different African kingdoms and groups for the purpose of acquiring more slaves that could be sold.'
          },
          {
            id: 40,
            title: "What was the overwhelming fundamental flaw when it came to African leaders at the time?",
            options: [
              'They lacked vision when it came to foreseeing how the excessive trade in humans could negatively impact the continent at large outside of their specific group of people.',
              'They failed to export enough slaves to equally profit from the slave trade.',
              'They focused too much on establishing peace between warring communities and not enough on leveraging their influence to export more slaves.'
            ],
            correctAnswer: 'They lacked vision when it came to foreseeing how the excessive trade in humans could negatively impact the continent at large outside of their specific group of people.'
          },
          {
            id: 41,
            title: "What is there to gain from analyzing the Atlantic slave trade objectively?",
            options: [
              'More evidence of how Black people are unable to make change without the help of others.',
              'A new perspective on how Europeans took advantage of African leaders.',
              'The ability to identify where African leaders fell short and establish a new direction.'
            ],
            correctAnswer: 'The ability to identify where African leaders fell short and establish a new direction.'
          }
        ]
      },
      13: {
        subStepTitle: 'Analyzing Legacies Of Disparity To Inspire Visionary Entrepreneurial Activity',
        subStepDescription: `<p>This section examines the legacies of disparity and how they can inspire entrepreneurial activity.</p>`,
        subStepVideoUrl: 'https://firebasestorage.googleapis.com/v0/b/online-resource-center.appspot.com/o/Masterclass%2F13.%20Analyzing%20Legacies%20Of%20Disparity%20To%20Inspire%20Visionary%20Entrepreneurial%20Activity.mp4?alt=media&token=54db8833-720c-4a7d-84ef-8f43663fef09',
        questions: [
          {
            id: 42,
            title: "What do all the statistics regarding Black household wealth around the world have in common?",
            options: [
              'Black people are overwhelmingly at the bottom of the economic totem pole.',
              'Black people are overwhelmingly at the top of the economic totem pole.',
              'Black people are overwhelmingly in the middle of the economic totem pole.'
            ],
            correctAnswer: 'Black people are overwhelmingly at the bottom of the economic totem pole.'
          },
          {
            id: 43,
            title: "What do all the statistics regarding Black employment around the world have in common?",
            options: [
              'Black people are overwhelmingly in relatively decent-paying jobs...',
              'Black people are overwhelmingly in high-paying jobs...',
              'Black people are overwhelmingly in low-paying jobs...'
            ],
            correctAnswer: 'Black people are overwhelmingly in low-paying jobs...'
          },
          {
            id: 44,
            title: "Does education bridge the employment gap?",
            options: [
              'Yes',
              'No'
            ],
            correctAnswer: 'No'
          },
          {
            id: 45,
            title: "How did Black people enter capitalism?",
            options: [
              'As equal players.',
              'As commodities.',
              'As the group with the upper hand.'
            ],
            correctAnswer: 'As commodities.'
          },
          {
            id: 46,
            title: "Why is it important to be aware of the Black-White wealth and employment gaps?",
            options: [
              'Such awareness prepares you to take wealth building seriously and be proactive about pursuing alternatives to traditional employment such as business ownership.',
              'Such awareness empowers you to work ten times harder than other groups of people so that you can overcome such barriers.',
              'Such awareness prepares you to develop an individualistic go-getter mindset so that you can beat the odds.'
            ],
            correctAnswer: 'Such awareness prepares you to take wealth building seriously and be proactive about pursuing alternatives to traditional employment such as business ownership.'
          },
          {
            id: 47,
            title: "What is the value of entrepreneurship?",
            options: [
              'It gives you the autonomy to not have to work hard.',
              'It gives you the autonomy to become rich overnight.',
              'It gives you the autonomy to create your own opportunity that can supplement underemployment or sustain you full-time.'
            ],
            correctAnswer: 'It gives you the autonomy to create your own opportunity that can supplement underemployment or sustain you full-time.'
          }
        ]
      },
      14: {
        subStepTitle: 'Leveraging Entrepreneurship To Awaken The Black Visionary Leader In You',
        subStepDescription: `<p>This section explores how entrepreneurship can awaken the visionary leader within you.</p>`,
        subStepVideoUrl: 'https://firebasestorage.googleapis.com/v0/b/online-resource-center.appspot.com/o/Masterclass%2F14.%20Leveraging%20Entrepreneurship%20To%20Awaken%20The%20Black%20Visionary%20Leader%20In%20You.mp4?alt=media&token=6ef26ba9-2dd8-44c3-871b-27b2990f301c',
        questions: [
          {
            id: 48,
            title: "What is the difference between talent and passion, and how does entrepreneurship leverage both?",
            options: [
              "A talent is something you are naturally good at, while a passion is something you love doing and would therefore do for free. Entrepreneurship requires your talent to bring your idea to fruition and your passion to drive your idea forward through the hard times.",
              "A talent is something you worked hard to develop, while a passion is something you are naturally good at and would therefore do for free. Entrepreneurship leverages both by requiring you to work hard.",
              "A talent is something you are naturally good at, while a passion is something you love doing and would therefore only do for a fee. Entrepreneurship requires your talent to reach the idea stage and your passion to make it a reality."
            ],
            correctAnswer: "A talent is something you are naturally good at, while a passion is something you love doing and would therefore do for free. Entrepreneurship requires your talent to bring your idea to fruition and your passion to drive your idea forward through the hard times."
          },
          {
            id: 49,
            title: "What is the primary role of an entrepreneur?",
            options: [
              "To create and share ideas with others in the community.",
              "To take the knowledge gained from experiences, talents and passion and turn it into an idea that is sellable and scalable.",
              "To take the knowledge gained from school and apply it to the creation of a business."
            ],
            correctAnswer: "To take the knowledge gained from experiences, talents and passion and turn it into an idea that is sellable and scalable."
          },
          {
            id: 50,
            title: "What is the value of creating a business as an entrepreneur?",
            options: [
              "It brings peace of mind and happiness, while creating a steady flow of income that you can be proud of.",
              "It brings peace of mind and happiness, while offering opportunities for advancement and leadership.",
              "It brings peace of mind and happiness, while offering opportunities to connect with the community and give back to the less fortunate."
            ],
            correctAnswer: "It brings peace of mind and happiness, while creating a steady flow of income that you can be proud of."
          },
          {
            id: 51,
            title: "Why is entrepreneurship critical to Black visionary leadership?",
            options: [
              "Entrepreneurship is one of the few areas where Black people have a level playing field.",
              "Entrepreneurship offers the autonomy and freedom necessary to create impactful change within the Black community.",
              "Entrepreneurship is the only area where Black people can control their own destinies."
            ],
            correctAnswer: "Entrepreneurship offers the autonomy and freedom necessary to create impactful change within the Black community."
          }
        ]
      },
      // 15: {
      //   subStepTitle: 'Thank you! You\'ve successfully completed the Masterclass',
      //   subStepDescription: `<p>Congratulations on completing the masterclass.</p>`
      // }
    }
  },
  {
    id: 1,
    decision: true,
    options: [
      { text: 'Finances & Philanthropy', nextStep: 2 },
      { text: 'Entrepreneurship & Philanthropy', nextStep: 8 }
    ]
  }
];

export default masterclassSteps;
